import { Component } from '@angular/core';
import { Privileges } from '@/auth/enum/auth.enum';
import { AuthService } from '@/auth/service/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {

  constructor(
    private auth: AuthService,
  ) { }

  get showPersonalRequest(): boolean {
    const acceptedPrivileges: Privileges[] = [
      'LICENSE EXTEND PERSONAL_CONTRACTOR',
      'LICENSE EXTEND PERSONAL_EMPLOYEE',
    ];

    return acceptedPrivileges.some((privilege) => this.auth.userHavePrivilege(privilege));
  }

  get showThirdPersonRequest(): boolean {
    const acceptedPrivileges: Privileges[] = [
      'LICENSE EXTEND THIRD_CONTRACTOR',
      'LICENSE EXTEND THIRD_EMPLOYEE',
    ];

    return acceptedPrivileges.some((privilege) => this.auth.userHavePrivilege(privilege));
  }

}
